"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _lib = require("../../lib");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var ArcMenu = function ArcMenu(_ref) {
  var menuItems = _ref.menuItems,
    mode = _ref.mode,
    defaultSelectedKeys = _ref.defaultSelectedKeys,
    defaultOpenKeys = _ref.defaultOpenKeys,
    theme = _ref.theme,
    collapsed = _ref.collapsed,
    width = _ref.width,
    displayKey = _ref.displayKey,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick;
  var display = displayKey ? displayKey : "label";
  return /*#__PURE__*/_react["default"].createElement(_lib.Menu, {
    mode: mode && mode,
    defaultSelectedKeys: defaultSelectedKeys,
    defaultOpenKeys: defaultOpenKeys,
    theme: theme,
    inlineCollapsed: collapsed,
    style: {
      width: width
    },
    onClick: onClick
  }, menuItems.length > 0 && menuItems.map(function (menu) {
    return menu.hassubmenu ? /*#__PURE__*/_react["default"].createElement(_lib.Menu.SubMenu, {
      key: menu.key,
      icon: (menu === null || menu === void 0 ? void 0 : menu.icon) && /*#__PURE__*/_react["default"].createElement("img", {
        src: menu === null || menu === void 0 ? void 0 : menu.icon,
        style: {
          width: "20px"
        }
      }),
      title: menu[display]
    }, menu.submenuItems.length > 0 && menu.submenuItems.map(function (item) {
      return item.hasItemGroup ? /*#__PURE__*/_react["default"].createElement(_lib.Menu.ItemGroup, {
        title: item[display]
      }, item.groupItems.length > 0 && item.groupItems.map(function (gpitem) {
        return /*#__PURE__*/_react["default"].createElement(_lib.Menu.Item, _extends({}, gpitem, {
          icon: (gpitem === null || gpitem === void 0 ? void 0 : gpitem.icon) && /*#__PURE__*/_react["default"].createElement("img", {
            src: gpitem === null || gpitem === void 0 ? void 0 : gpitem.icon,
            style: {
              width: "20px"
            }
          }),
          key: gpitem.key,
          onClick: function onClick() {
            return gpitem.onClick && gpitem.onClick(gpitem);
          }
        }), gpitem[display], (gpitem === null || gpitem === void 0 ? void 0 : gpitem.icons) && (gpitem === null || gpitem === void 0 ? void 0 : gpitem.icons.map(function (icon) {
          return /*#__PURE__*/_react["default"].createElement("img", {
            src: icon === null || icon === void 0 ? void 0 : icon.src,
            onClick: function onClick() {
              icon.onClick && icon.onClick(gpitem, icon);
            },
            style: {
              width: "20px"
            }
          });
        })));
      })) : item !== null && item !== void 0 && item.hassubmenu ? /*#__PURE__*/_react["default"].createElement(_lib.Menu.SubMenu, {
        key: item.key,
        icon: (item === null || item === void 0 ? void 0 : item.icon) && /*#__PURE__*/_react["default"].createElement("img", {
          src: item === null || item === void 0 ? void 0 : item.icon,
          style: {
            width: "20px"
          }
        }),
        title: item[display]
      }, (item === null || item === void 0 ? void 0 : item.submenuItems.length) > 0 && (item === null || item === void 0 ? void 0 : item.submenuItems.map(function (submenu) {
        return /*#__PURE__*/_react["default"].createElement(_lib.Menu.Item, {
          icon: (submenu === null || submenu === void 0 ? void 0 : submenu.icon) && /*#__PURE__*/_react["default"].createElement("img", {
            src: submenu === null || submenu === void 0 ? void 0 : submenu.icon,
            style: {
              width: "20px"
            }
          }),
          key: submenu.key,
          onClick: function onClick() {
            (submenu === null || submenu === void 0 ? void 0 : submenu.onClick) && (submenu === null || submenu === void 0 ? void 0 : submenu.onClick(submenu));
          }
        }, submenu[display], (submenu === null || submenu === void 0 ? void 0 : submenu.icons) && (submenu === null || submenu === void 0 ? void 0 : submenu.icons.map(function (icon) {
          return /*#__PURE__*/_react["default"].createElement("img", {
            src: icon === null || icon === void 0 ? void 0 : icon.src,
            onClick: function onClick() {
              icon.onClick && icon.onClick(submenu, icon);
            },
            style: {
              width: "20px"
            }
          });
        })));
      }))) : /*#__PURE__*/_react["default"].createElement(_lib.Menu.Item, {
        icon: (item === null || item === void 0 ? void 0 : item.icon) && /*#__PURE__*/_react["default"].createElement("img", {
          src: item === null || item === void 0 ? void 0 : item.icon,
          style: {
            width: "20px"
          }
        }),
        key: item.key,
        onClick: function onClick() {
          (item === null || item === void 0 ? void 0 : item.onClick) && (item === null || item === void 0 ? void 0 : item.onClick(item));
        }
      }, item[display], (item === null || item === void 0 ? void 0 : item.icons) && (item === null || item === void 0 ? void 0 : item.icons.map(function (icon) {
        return /*#__PURE__*/_react["default"].createElement("img", {
          src: icon === null || icon === void 0 ? void 0 : icon.src,
          onClick: function onClick() {
            icon.onClick && icon.onClick(item, icon);
          },
          style: {
            width: "20px"
          }
        });
      })));
    })) : /*#__PURE__*/_react["default"].createElement(_lib.Menu.Item, {
      key: menu.key,
      icon: (menu === null || menu === void 0 ? void 0 : menu.icon) && /*#__PURE__*/_react["default"].createElement("img", {
        src: menu === null || menu === void 0 ? void 0 : menu.icon,
        style: {
          width: "20px"
        }
      }),
      onClick: function onClick() {
        (menu === null || menu === void 0 ? void 0 : menu.onClick) && (menu === null || menu === void 0 ? void 0 : menu.onClick(menu));
      }
    }, menu[display], (menu === null || menu === void 0 ? void 0 : menu.icons) && (menu === null || menu === void 0 ? void 0 : menu.icons.map(function (icon) {
      return /*#__PURE__*/_react["default"].createElement("img", {
        src: icon === null || icon === void 0 ? void 0 : icon.src,
        onClick: function onClick() {
          icon.onClick && icon.onClick(menu, icon);
        },
        style: {
          width: "20px"
        }
      });
    })));
  }));
};
var _default = ArcMenu;
exports["default"] = _default;